import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { AppService } from './shared/service/app/app.service';
import { AuthService } from './shared/service/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange() {
    if (window.orientation === 90 || window.orientation === -90) {
      Swal.fire({
        toast: true,
        icon: 'warning',
        title: '¡Atención!',
        text: 'Te recomiendo mantener el telefono en posición vertical para que tengas una mejor experiencia.',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        position: 'top',
      });
    }
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private appService: AppService,
    private authService: AuthService,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        switchMap((route) => {
          return route.data.pipe(
            map((routeData: any) => {
              const title = routeData['title'];
              return { title };
            }),
          );
        }),
        tap((data: any) => {
          let title = data.title;
          title = (title ? title + ' | ' : '') + 'PITZON';
          this.titleService.setTitle(title);
        }),
      )
      .subscribe();
  }
  ngOnInit(): void {
    this.appService.initStoreData();

    // Check if user has a valid token and update authentication state
    const token = localStorage.getItem('secTkn');
    if (token) {
      this.authService.setAuthenticated(true);
      console.log('User has an existing token, authentication state updated');
    }
  }
}
